export const TennisMoreBets = `
{{? data.moreBets}}
{{var events = data.moreBets[3];}}
{{var marketNo = data.marketNo.periods;}}
{{var sportId = data.moreBets[0];}}
{{var betTypePeriod = data.betTypePeriod;}}
{{var periodNum = data.period;}}
{{var sportGroup = SportGroup.stringOf(data.moreBets[2]).toLowerCase();}}
{{var ot = data.ot;}}
{{var isParlay = (data.isParlay || data.isParlayMarket);}}
{{var favSel = data.favSel;}}
{{var periodsDescription = data.periodsDescription;}}
{{var parentEvent = findEventParentMoreBet(events);}}
{{var childEvent = data.secondEvent || [];}}
{{var homeTeamName = parentEvent[24];}}
{{var awayTeamName = parentEvent[25];}}
{{var firstEv = data && data.firstEvent && data.firstEvent[0] ? data.firstEvent[0] : 0;}}
{{var secondEv = data && data.secondEvent && data.secondEvent[0] ?  data.secondEvent[0] : 0;}}
{{var eventId = (firstEv && firstEv == secondEv ? 0 : firstEv) + '_' + secondEv + '_' + periodNum;}}
{{var nameParentEventHome = parentEvent[27] === 'Sets' ?  parentEvent[1].split('(')[0] : parentEvent[1];}}
{{var nameParentEventAway = parentEvent[27] === 'Sets' ?  parentEvent[2].split('(')[0] : parentEvent[2];}}
<div class='more-bets tennis-more-bets status_{{=parentEvent[17]}} {{? eventId}} e{{=eventId}} {{?}}'>
	<!-- Add team name to more-bet-->
  {{? eventId}}
	<div class="team-name {{=favSel && favSel.isNoUnderDog ? 'no-underdog' : ''}}" id="{{=eventId}}">
		<span class="team-a {{=favSel && favSel.favHome}}">{{=nameParentEventHome}}</span>
		<span class="vs"> -vs- </span>
		<span class="team-b {{=favSel && favSel.favAway}}">{{=nameParentEventAway}}</span>
		<span class="close-icon tennis" id="{{=eventId}}"></span>
	</div>
  {{?}}
	{{var teamNames = nameParentEventHome + ' -vs- ' + nameParentEventAway;}}
	<div class="table-market border-top border-left table-market-border-right">
 
		{{var noColumn = 1;}}
		{{? (!data.singleLine && data.marketNo.allMarket > 0) || (data.singleLine && (firstEv != 0 || data.marketNo.allMarket > 1))}}
			<div class="market-item border-right {{= noColumn % 4 > 0 ? '' : 'col-border-right'}} border-bottom {{=data.marketSecledted == 'All' ? 'selected' : ''}}" data-mk='All'>{{=i18n(sportGroup,'AllMarkets')}}</div>
		{{?}}
    {{var validEvents = events.filter(function(ev) {return betTypePeriod > 0 || (ev[27] && ev[27].toLowerCase() != "regular");});}}
    {{var periods = validEvents.reduce(function(pe, e){ return pe.concat(Object.keys(e[8]));}, []);}}
    {{var finalPeriods = betTypePeriod > 0 || data.favourite ? [...new Set(periods)] : [periodNum];}}
    {{var panelValidEvent = events.filter(function(ev) {return ev[8][periodNum] && (ev[8][periodNum][0] || ev[8][periodNum][2].length > 0 || ev[8][periodNum][3].length > 0);});}}
    {{var unitEv = panelValidEvent.length > 0 ? panelValidEvent[0] : {};}}
    {{~finalPeriods :pe:pe_index}}
			{{var noMLEvent = data.marketNo.periods[pe]['ml'];}}
			{{var noMLEventSets = data.marketNo.periods[pe]['mlSets'];}}
			{{var noMLEventGames = data.marketNo.periods[pe]['mlGames'];}}
			{{var noHDPOUEvent = data.marketNo.periods[pe]['hdp'] + data.marketNo.periods[pe]['ou'];}}
      {{var noHDPOUEventSets = data.marketNo.periods[pe]['hdpSets'] + data.marketNo.periods[pe]['ouSets'];}}
      {{var noHDPOUEventGames = data.marketNo.periods[pe]['hdpGames'] + data.marketNo.periods[pe]['ouGames'];}}
      {{var noTTEventSets = data.marketNo.periods[pe]['ttSets'];}}
      {{var noTTEventGames = data.marketNo.periods[pe]['ttGames'];}}
      {{var noTTEvent = data.marketNo.periods[pe]['tt'];}}
			{{var hide1x2Txt = sportId == 29 && pe == 8;}}
      {{var labelMarketUnitParentML = parentEvent[27] && parentEvent[27].toLowerCase() === 'regular' ? 'Sets' : parentEvent[27];}}
      {{var labelMarketUnitML = childEvent[27] && childEvent[27].toLowerCase() === 'regular' ? 'Sets' : childEvent[27];}}
      {{? childEvent[30]}}
        {{labelMarketUnitML = 'Games';}}
      {{?}}
      {{var isUnitParentSets = parentEvent[27] && parentEvent[27].toLowerCase() === 'sets';}}
      {{var labelMarketUnitParent = parentEvent[27] && parentEvent[27].toLowerCase() === 'regular' ? 'Games' : parentEvent[27];}}
      {{var labelMarketUnitEv = childEvent[27] && childEvent[27].toLowerCase() === 'regular' ? 'Games' : childEvent[27];}}
      {{? noHDPOUEventSets === 0 && childEvent[27] === 'Sets'}}
        {{labelMarketUnitEv = 'Games';}}
      {{?}}
      {{var isMLEventParent = (noMLEvent > 0 && noMLEvent === 1) || noMLEventSets === 2; }}
      {{var isSetEvent = childEvent[27] === "Sets";}}
      {{var isHDPEventParent = noHDPOUEventSets > 0 && noHDPOUEventGames > 0;}}
      {{var isTTEventParent = noTTEventSets > 0 && noTTEventGames > 0;}}
		  {{? noMLEvent > 0}}
        {{? noMLEventSets > 0}}
				  {{var noColumn = noColumn + 1;}}
        	<div class="market-item border-right {{= noColumn % 4 > 0 ? '' : 'col-border-right'}} border-bottom {{=data.marketSecledted == ('1x2_sets_' + pe) ? 'selected' : ''}}" data-mk='{{='1x2_sets_' + pe}}'>
          	{{=getPeriodsName(periodsDescription, sportId, pe, false)}} {{=!hide1x2Txt ? '-&nbsp;' + i18n(sportGroup,'1X2') : ''}} {{="(" +i18n(labelMarketUnitParentML) + ")"}}
				  </div>
        {{?}}
        {{? noMLEventGames > 0}}
        	{{var noColumn = noColumn + 1; }}
          <div class="market-item border-right {{= noColumn % 4 > 0 ? '' : 'col-border-right'}} border-bottom {{=data.marketSecledted == ('1x2_games_' + pe) ? 'selected' : ''}}" data-mk='{{='1x2_games_' + pe}}'>
            {{=getPeriodsName(periodsDescription, sportId, pe, false)}} {{=!hide1x2Txt ? '-&nbsp;' + i18n(sportGroup,'1X2') : ''}} {{="(" +i18n(labelMarketUnitML) + ")"}}
        	</div>
       	{{?}}
      {{?}}  
			{{? noHDPOUEvent > 0}}
        {{? noHDPOUEventSets > 0}}
				  {{var noColumn = noColumn + 1; }}
				  <div class="market-item border-right {{= noColumn % 4 > 0 ? '' : 'col-border-right'}} border-bottom {{=data.marketSecledted == ('hdp_sets_' + pe) ? 'selected' : ''}}" data-mk='{{='hdp_sets_' + pe}}'>
				    {{=getPeriodsName(periodsDescription, sportId, pe, false)}} - {{=i18n(sportGroup, 'HANDICAP')}}/{{=i18n(sportGroup,'Over Under')}} {{="(" + i18n(labelMarketUnitParent) + ")"}}
				  </div>
        {{?}}
        {{? noHDPOUEventGames > 0}}
				  {{var noColumn = noColumn + 1; }}
				  <div class="market-item border-right {{= noColumn % 4 > 0 ? '' : 'col-border-right'}} border-bottom {{=data.marketSecledted == ('hdp_games_' + pe) ? 'selected' : ''}}" data-mk='{{='hdp_games_' +  pe}}'>
				    {{=getPeriodsName(periodsDescription, sportId, pe, false)}} - {{=i18n(sportGroup, 'HANDICAP')}}/{{=i18n(sportGroup,'Over Under')}} {{="(" + i18n(labelMarketUnitEv) + ")"}}
				  </div>
        {{?}}
			{{?}}
			{{? noTTEvent > 0}}
        {{? noTTEventSets > 0}}
				  {{var noColumn = noColumn + 1; }}
				  <div class="market-item border-right {{= noColumn % 4 > 0 ? '' : 'col-border-right'}} border-bottom {{=data.marketSecledted == ('tt_sets_' + pe) ? 'selected' : ''}}" data-mk='{{='tt_sets_' + pe}}'>
					  {{=getPeriodsName(periodsDescription, sportId, pe, false)}} - {{=i18n(sportGroup,'Team Totals')}} {{="(" + i18n(labelMarketUnitParent) + ")"}}
				  </div>
        {{?}}
        {{? noTTEventGames > 0}}
        {{var noColumn = noColumn + 1; }}
        <div class="market-item border-right {{= noColumn % 4 > 0 ? '' : 'col-border-right'}} border-bottom {{=data.marketSecledted == ('tt_games_' + pe) ? 'selected' : ''}}" data-mk='{{='tt_games_' + pe}}'>
          {{=getPeriodsName(periodsDescription, sportId, pe, false)}} - {{=i18n(sportGroup,'Team Totals')}} {{="(" + i18n(labelMarketUnitEv) + ")"}}
        </div>
        {{?}}
			{{?}}
    {{~}}
    {{? data.marketNo.cornersCount > 0}}
			{{var noColumn = noColumn + 1; }}
			<div class="market-item border-bottom border-right {{= noColumn % 4 > 0 ? '' : 'col-border-right'}} {{=data.marketSecledted == 'mk-co' ? 'selected' : ''}}" data-mk='mk-co'>
				{{=i18n('corners')}} {{="(" + data.marketNo.cornersCount +")"}}
			</div>
    {{?}}
    {{? data.marketNo.bookingsCount > 0}}
			{{var noColumn = noColumn + 1; }}
			<div class="market-item border-bottom border-right {{= noColumn % 4 > 0 ? '' : 'col-border-right'}} {{=data.marketSecledted == 'mk-bo' ? 'selected' : ''}}" data-mk='mk-bo'>
				{{=i18n('bookings')}} {{="(" + data.marketNo.bookingsCount +")"}}
			</div>
    {{?}}
		{{? data.marketNo.teamProps > 0}}
			{{var noColumn = noColumn + 1; }}
			<div class="market-item border-bottom border-right {{= noColumn % 4 > 0 ? '' : 'col-border-right'}} {{=data.marketSecledted == 'mk-or' ? 'selected' : ''}}" data-mk='mk-or'>
				{{=i18n(sportGroup,'Team Props')}} {{="(" + data.marketNo.teamProps +")"}}
			</div>
    {{?}}
    {{? data.marketNo.playerProps > 0}}
			{{var noColumn = noColumn + 1; }}
			<div class="market-item border-bottom border-right {{= noColumn % 4 > 0 ? '' : 'col-border-right'}} {{=data.marketSecledted == 'mk-po' ? 'selected' : ''}}" data-mk='mk-po'>
				{{=i18n('Player Props','Player Props')}} {{="(" + data.marketNo.playerProps +")"}}
			</div>
    {{?}}
    <!-- Minute Markets -->
    {{?data.marketNo.minuteMarkets}}
    {{var ml_minuteMarkets = data.marketNo.minuteMarkets['ml'];}}
    {{var hdp_ou_minuteMarkets = data.marketNo.minuteMarkets['hdp_ou'];}}
    {{var tt_minuteMarkets = data.marketNo.minuteMarkets['tt'];}}
    {{? ml_minuteMarkets.periods.length > 0}}
      {{var noColumn = noColumn + 1; }}
      {{var ml_1x2 = ml_minuteMarkets.periods.some(function(period) {return data.minuteMoreBets[3][8][period][4][2]});}}
      <div class="market-item border-right {{= noColumn % 4 > 0 ? '' : 'col-border-right'}} border-bottom {{=data.marketSecledted == ('ml' + ml_minuteMarkets.periods.join('_')) ? 'selected' : ''}}" data-mk='{{='ml_' + ml_minuteMarkets.periods.join('_')}}'>
        {{=i18n('Minutes')}} - {{=ml_1x2 ? i18n(sportGroup, '1x2') : i18n("others","e_moneyline")}}  ({{=ml_minuteMarkets.totalEvents}})
      </div>
    {{?}}
    {{? hdp_ou_minuteMarkets.periods.length > 0}}
      {{var noColumn = noColumn + 1; }}
      <div class="market-item border-right {{= noColumn % 4 > 0 ? '' : 'col-border-right'}} border-bottom {{=data.marketSecledted == ('hdp_ou_' + hdp_ou_minuteMarkets.periods.join('_')) ? 'selected' : ''}}" data-mk='{{='hdp_ou_' + hdp_ou_minuteMarkets.periods.join('_')}}'>
        {{=i18n('Minutes')}} - {{=i18n(sportGroup, 'HANDICAP')}}/{{=i18n(sportGroup,'Over Under')}} ({{=hdp_ou_minuteMarkets.totalEvents}})
      </div>
    {{?}}
    {{? tt_minuteMarkets.periods.length > 0}}
      {{var noColumn = noColumn + 1; }}
      <div class="market-item border-right {{= noColumn % 4 > 0 ? '' : 'col-border-right'}} border-bottom {{=data.marketSecledted == ('tt_' + tt_minuteMarkets.periods.join('_')) ? 'selected' : ''}}" data-mk='{{='tt_' + tt_minuteMarkets.periods.join('_')}}'>
        {{=i18n('Minutes')}} - {{=i18n(sportGroup,'Team Totals')}} ({{=tt_minuteMarkets.totalEvents}})
      </div>
    {{?}}
    {{?}}
   
    <!-- End Minute Markets -->
  </div>

  <div class="is-loading"></div>

	<!--1X2-->  
  {{~events :ev:ev_index}}
      {{var periods = betTypePeriod > 0 || data.favourite ? Object.keys(ev[8]) : [periodNum];}}
      {{~periods :pe:pe_index}}
        {{? marketNo[pe]['ml'] > 0}}
        {{var period = ev[8][pe];}}
        {{? period && period[4]}}
        {{var _1x2 = period[4][2] > 0;}}
        {{unitEv = ev[27] === 'Regular' ? 'Sets' : ev[27];}}
        {{var currentClass = '1x2_' + unitEv.toLowerCase() + '_' + pe;}}
        {{var isAddHidden = data.marketSecledted != 'All' && data.marketSecledted !== currentClass;}}
        {{var hide1x2Txt = sportId == 29 && pe == 8;}}
        {{var labelMarket = ev[27] && ev[27].toLowerCase() === 'regular' ? (ev[30] ? 'Games' : 'Sets') : ev[27];}}
        <table class='more-1x2 more-market {{=currentClass}}{{= isAddHidden ? " hidden" : ""}} status_{{=period[13]}}'>
          <thead>
            <tr><th colspan="{{=_1x2 ? 3 : 2}}">
                {{=getPeriodsName(periodsDescription, sportId, period[5], false)}}  {{=(!hide1x2Txt ? '-&nbsp;' + i18n(sportGroup,'MORE_1x2') : '')}} ({{=i18n(labelMarket)}})
                <span class="toggle-lg expand more-bets" id="mb-1x2_{{=ev_index}}_{{=pe}}"/>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class='header-content'>
              <td><span class="home-team-name" title="{{=homeTeamName}}"><span>{{=homeTeamName}}</span></span></td>
              {{? _1x2}}
              <td>{{=i18n(sportGroup,'Draw')}}</td>
              {{?}}
              <td><span class="away-team-name" title="{{=awayTeamName}}"><span>{{=awayTeamName}}</span></span></td>
            </tr>
            <tr class="mkline">
              <td>
                <a class="odds more-odds {{=period[4][1] < 0 ? 'fav neg': ''}}"
                  data-oddsid="{{=period[4][3]}}"
                  data-date="{{=ev[4]}}"
                  data-pl-res="{{=ev[22]}}"
                  data-team-type="{{=ev[11][0]}}"
                  id="{{=ev[0]}}|{{=pe}}|1|0|{{=period[4][4]?1:0}}|0"
                >
                  {{? ot === OddsFormat.American}}
                    <span>{{? period[4][1] > 0}}+{{?}}{{=period[4][1]}}</span>
                  {{??}}
                    <span>{{=period[4][1].formatSeparators()}}</span>
                  {{?}}
                </a>
              </td>
              {{? _1x2}}
              <td>
                <a class="odds more-odds {{=period[4][2] < 0 ? 'fav neg': ''}}"
                  data-oddsid="{{=period[4][3]}}"
                  data-date="{{=ev[4]}}"
                  data-pl-res="{{=ev[22]}}"
                  data-team-type="2"
                  id="{{=ev[0]}}|{{=pe}}|1|2|{{=period[4][4]?1:0}}|0"
                >
                  {{? ot === OddsFormat.American}}
                    <span>{{? period[4][2] > 0}}+{{?}}{{=period[4][2]}}</span>
                  {{??}}
                    <span>{{=period[4][2].formatSeparators()}}</span>
                  {{?}}
                </a>
              </td>
              {{?}}
              <td>
                <a class="odds more-odds {{=period[4][0] < 0 ? 'fav neg': ''}}"
                  data-oddsid="{{=period[4][3]}}"
                  data-date="{{=ev[4]}}"
                  data-pl-res="{{=ev[22]}}"
                  data-team-type="{{=ev[11][1]}}"
                  id="{{=ev[0]}}|{{=pe}}|1|1|{{=period[4][4]?1:0}}|0"
                >
                  {{? ot === OddsFormat.American}}
                    <span>{{? period[4][0] > 0}}+{{?}}{{=period[4][0]}}</span>
                  {{??}}
                    <span>{{=period[4][0].formatSeparators()}}</span>
                  {{?}}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        {{?}} <!--if period -->
        {{?}}<!--if show1x2 -->
      {{~}}
    {{~}}

	<!--HDP&OU-->
  {{~events :ev:ev_index}}
    {{var periods = betTypePeriod > 0 || data.favourite ? Object.keys(ev[8]) : [periodNum];}}
    {{~periods :pe:pe_index}} 
      {{var isValidPeriodNum = pe > 1;}}
      {{var tempStartIndex = 0;}}
      {{var lines = new Array().init(ev[3], isValidPeriodNum ? 0 : tempStartIndex);}}
      {{? lines.length > 0 && (lines[0] >= tempStartIndex || isValidPeriodNum)}}
      {{var period = ev[8][pe];}}
      {{? period && period[3]&& period[2]}}     
      {{var _hdpLines = period[2] || [];}}
      {{var _ouLines = period[3] || [];}}
      {{? _hdpLines.length > tempStartIndex || _ouLines.length > tempStartIndex || isValidPeriodNum}}
      <!-- Check length of _hdpLines and _ouLines to display the HDP&OU more bets -->
      {{var isDisplayed = _hdpLines.length > 0 || _ouLines.length > 0;}}
      {{? isDisplayed}}
      {{unitEv = ev[27] === 'Regular' ? 'Games' : ev[27];}}
      {{var currentClass = 'hdp_' + unitEv.toLowerCase() + '_' + pe;}}
      {{var isAddHidden = data.marketSecledted != 'All' && data.marketSecledted !== currentClass;}}
      {{var labelMarket = ev[27] && ev[27].toLowerCase() === 'regular' ? 'Games' : ev[27];}}
      {{var resultingUnit = ev[27] && ev[27].toLowerCase() == 'regular' ? ev[32] : ev[27];}}
      <table class="more-HDPOU more-market {{=currentClass}}{{= isAddHidden ? " hidden" : ""}} status_{{=period[13]}}">
        <thead>
          <tr>
            <th colspan="7">
              {{=getPeriodsName(periodsDescription, sportId, period[5], false)}} - {{=i18n(sportGroup,'HANDICAP')}} / {{=i18n(sportGroup,'Over Under')}} ({{=i18n(labelMarket)}})
              <span class="toggle-lg expand more-bets" id="mb-hdp_{{=ev_index}}_{{=pe}}" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class='header-content'>
            <td>{{=i18n('Event')}}</td>
            <td class="hdp more-hdp">{{=i18n('HDP')}}</td>
            <td class="odds more-odds"><span class="home-team-name" title="{{=homeTeamName}}"><span>{{=homeTeamName}}</span></span></td>
            <td class="odds more-odds"><span class="away-team-name" title="{{=awayTeamName}}"><span>{{=awayTeamName}}</span></span></td>
            <td class="hdp more-hdp">{{=i18n(resultingUnit)}}</td>
            <td class="odds more-odds">{{=i18n('Over')}}</td>
            <td class="odds more-odds">{{=i18n('Under')}}</td>
          </tr>
          {{~lines :line:line_index}}
          {{var _hdp = _hdpLines.length > line && _hdpLines[line];}}
          {{var _ou = _ouLines.length > line && _ouLines[line];}}
          {{? _hdp || _ou}}
          <tr class="mkline">
            {{?line == 0}}
              <td class='event-team-name {{=_hdp&&(_hdp[6]||_hdp[5])? "": "no-underdog"}}' rowspan={{=Math.max(_hdpLines.length, _ouLines.length)}}>
                <span class='home-away-team-name' title="{{=homeTeamName}} - {{=awayTeamName}}">
                  <span class='{{=_hdp && _hdp[5] ? "favSel": "sel"}} home-team-name' title="{{=homeTeamName}}"><span>{{=homeTeamName}}</span></span>
                  <span class='sign'>&nbsp;-&nbsp;</span>
                  <span class='{{=_hdp && _hdp[6] ? "favSel": "sel"}} away-team-name' title="{{=awayTeamName}}"><span>{{=awayTeamName}}</span></span>
                <span>
              </td>
            {{?}}
            <td class='hdp more-hdp'>
              <span class='hdp'>{{=_hdp ? _hdp[2].formatSeparators() : '&nbsp;'}}</span>
            </td>
            <td class="odds more-odds">
              {{? _hdp}}
              <a class="odds {{=_hdp[3] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=_hdp[7]}}"
                          data-date="{{=ev[4]}}"
                data-pl-res="{{=ev[22]}}"
                data-team-type="{{=ev[11][0]}}"
                id="{{=ev[0]}}|{{=pe}}|2|0|{{=_hdp[8]?1:0}}|{{=_hdp[1]}}"
                >
                {{? ot === OddsFormat.American}}
                  <span>{{? _hdp[3] > 0}}+{{?}}{{=_hdp[3]}}</span>
                {{??}}
                  <span>{{=_hdp[3].formatSeparators()}}</span>
                {{?}}
              </a>
              {{??}}&nbsp;
              {{?}}                    
            </td>
            <td class="odds more-odds">
              {{? _hdp}}
              <a class="odds {{=_hdp[4] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=_hdp[7]}}"
                          data-date="{{=ev[4]}}"
                data-pl-res="{{=ev[22]}}"
                data-team-type="{{=ev[11][1]}}"
                id="{{=ev[0]}}|{{=pe}}|2|1|{{=_hdp[8]?1:0}}|{{=_hdp[0]}}"
                >
                {{? ot === OddsFormat.American}}
                  <span>{{? _hdp[4] > 0}}+{{?}}{{=_hdp[4]}}</span>
                {{??}}
                  <span>{{=_hdp[4].formatSeparators()}}</span>
                {{?}}
              </a>
              {{??}}&nbsp;
              {{?}}                    
            </td>
            <td class='hdp more-hdp'>                    
              <span>{{=_ou ? _ou[0].formatSeparators(): '&nbsp;'}}</span>                    
            </td>
            <td class="odds more-odds">
              {{? _ou}}
              <a class="odds {{=_ou[2] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=_ou[4]}}"
                          data-date="{{=ev[4]}}"
                data-pl-res="{{=ev[22]}}"
                data-team-type="0"
                id="{{=ev[0]}}|{{=pe}}|3|3|{{=_ou[5]?1:0}}|{{=_ou[1]}}"
                >
                {{? ot === OddsFormat.American}}
                  <span>{{? _ou[2] > 0}}+{{?}}{{=_ou[2]}}</span>
                {{??}}
                  <span>{{=_ou[2].formatSeparators()}}</span>
                {{?}}
              </a>
              {{??}}
              &nbsp;
              {{?}}
            </td>
            <td class="odds more-odds">
              {{? _ou}}
              <a class="odds {{=_ou[3] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=_ou[4]}}"
                          data-date="{{=ev[4]}}"
                data-pl-res="{{=ev[22]}}"
                data-team-type="1"
                id="{{=ev[0]}}|{{=pe}}|3|4|{{=_ou[5]?1:0}}|{{=_ou[1]}}"
                >
                {{? ot === OddsFormat.American}}
                    <span>{{? _ou[3] > 0}}+{{?}}{{=_ou[3]}}</span>
                {{??}}
                  <span>{{=_ou[3].formatSeparators()}}</span>
                {{?}}
              </a>
              {{??}}
              &nbsp;
              {{?}}
            </td>
          </tr>
          {{?}}
          {{~}}
        </tbody>
      </table>
      {{?}}
      {{?}}
      {{?}}
      {{?}}
    {{~}}
{{~}}

	<!--TT-->   
  {{~events :ev:ev_index}}
    {{var periods = betTypePeriod > 0 || data.favourite ? Object.keys(ev[8]) : [periodNum];}}
    {{~periods :pe:pe_index}} 
      {{? marketNo[pe]['tt'] > 0}}
      {{var period = ev[8][pe];}}
      {{? period && period[0]}}
      {{var fttt = period[0];}}
      {{unitEv = ev[27] === 'Regular' ? 'Games' : ev[27];}}
      {{var currentClass = 'tt_' + unitEv.toLowerCase() + '_' + pe; }}
      {{var isAddHidden = data.marketSecledted != 'All' && data.marketSecledted !== currentClass;}}
      {{var labelMarket = ev[27] && ev[27].toLowerCase() === 'regular' ? 'Games' : ev[27];}}
      {{var resultingUnit = ev[27] && ev[27].toLowerCase() == 'regular' ? ev[32] : ev[27];}}
      <table class='more-TT more-market {{=currentClass}}{{= isAddHidden ? " hidden" : ""}} status_{{=period[13]}}'>
        <thead>
          <tr>
            <th colspan="6">
              {{=getPeriodsName(periodsDescription, sportId, period[5], false)}} - {{=i18n(sportGroup,'Team Totals')}} ({{=i18n(labelMarket)}})
              <span class="toggle-lg expand more-bets" id="mb-tt_{{=ev_index}}_{{=pe}}" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class='header-content'>
            <td class="hdp more-hdp"><span class="home-team-name" title="{{=homeTeamName}}"><span>{{=homeTeamName}}</span> {{=i18n(resultingUnit)}}</span></td>
            <td class="odds more-odds"><span class="home-team-name">{{=i18n('Over')}}</span></td>
            <td class="odds more-odds"><span class="home-team-name">{{=i18n('Under')}}</span></td>
            <td class="hdp more-hdp"><span class="away-team-name" title="{{=awayTeamName}}"><span>{{=awayTeamName}}</span> {{=i18n(resultingUnit)}}</span></td>
            <td class="odds more-odds"><span class="away-team-name">{{=i18n('Over')}}</span></td>
            <td class="odds more-odds"><span class="away-team-name">{{=i18n('Under')}}</span></td>
          </tr>
          <tr class="mkline">
            <td class="hdp more-hdp">                    
              {{? fttt}}
                <span class='hdp'>{{=fttt[0][0].formatSeparators()}}</span>
              {{??}}
                &nbsp;
              {{?}}
            </td>
            <td class="odds more-odds">
              {{? fttt}}
              <a class="odds {{=fttt[0][2] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=fttt[0][4]}}"
                          data-date="{{=ev[4]}}"
                data-pl-res="{{=ev[22]}}"
                data-team-type="{{=ev[11][0]}}"
                id="{{=ev[0]}}|{{=period[5]}}|4|5|{{=fttt[0][5]?1:0}}|{{=fttt[0][1]}}"
                >
                {{? ot === OddsFormat.American}}
                  <span>{{? fttt[0][2] > 0}}+{{?}}{{=fttt[0][2]}}</span>
                {{??}}
                  <span>{{=fttt[0][2].formatSeparators()}}</span>
                {{?}}
              </a>
              {{??}}&nbsp;
              {{?}}
            </td>                
            <td class="odds more-odds">
              {{? fttt}}
                <a class="odds {{=fttt[0][3] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=fttt[0][4]}}"
                data-date="{{=ev[4]}}"
                data-pl-res="{{=ev[22]}}"
                data-team-type="{{=ev[11][0]}}"
                id="{{=ev[0]}}|{{=period[5]}}|4|6|{{=fttt[0][5]?1:0}}|{{=fttt[0][1]}}"
                >
                  {{? ot === OddsFormat.American}}
                    <span>{{? fttt[0][3] > 0}}+{{?}}{{=fttt[0][3]}}</span>
                  {{??}}
                    <span>{{=fttt[0][3].formatSeparators()}}</span>
                  {{?}}
                </a>
              {{??}}
                &nbsp;
              {{?}}
            </td>
            <td class="hdp more-hdp">
              {{? fttt}}
                <span class='hdp'>{{=fttt[1][0].formatSeparators()}}</span>
              {{??}}
                &nbsp;
              {{?}}
            </td>                
            <td class="odds more-odds">
              {{? fttt}}
                <a class="odds {{=fttt[1][2] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=fttt[1][4]}}"
                data-date="{{=ev[4]}}"
                data-pl-res="{{=ev[22]}}"
                data-team-type="{{=ev[11][1]}}"
                id="{{=ev[0]}}|{{=period[5]}}|5|7|{{=fttt[1][5]?1:0}}|{{=fttt[1][1]}}"
                >
                  {{? ot === OddsFormat.American}}
                    <span>{{? fttt[1][2] > 0}}+{{?}}{{=fttt[1][2]}}</span>
                  {{??}}
                    <span>{{=fttt[1][2].formatSeparators()}}</span>
                  {{?}}
                </a>
              {{??}}
                &nbsp;
              {{?}}
            </td>                
            <td class="odds more-odds">
              {{? fttt}}
                <a class="odds {{=fttt[1][3] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=fttt[1][4]}}"
                data-date="{{=ev[4]}}"
                data-pl-res="{{=ev[22]}}"
                data-team-type="{{=ev[11][1]}}"
                id="{{=ev[0]}}|{{=period[5]}}|5|8|{{=fttt[1][5]?1:0}}|{{=fttt[1][1]}}"
                >
                  {{? ot === OddsFormat.American}}
                    <span>{{? fttt[1][3] > 0}}+{{?}}{{=fttt[1][3]}}</span>
                  {{??}}
                    <span>{{=fttt[1][3].formatSeparators()}}</span>
                  {{?}}
                </a>
              {{??}}
                &nbsp;
              {{?}}
            </td>
          </tr>
        </tbody>
      </table>
      {{?}}
      {{?}}<!--if showTT-->
    {{~}}
	{{~}} 
			
	{{var participant_count = 1, nowTime = moment(), leagueTime;}}
	{{var ot = data.ot;}}
	{{var leagues = data.outrightEvents;}}
	{{?leagues && leagues.length > 0 && !isParlay}}    
	{{var currentClass = 'mk-or'; }}
	{{var isAddHidden = data.marketSecledted != 'All' && data.marketSecledted != 'Outright';}}
	<div class="more-outright more-market {{=currentClass}}{{= isAddHidden ? " hidden" : ""}}">
		{{~leagues :lg:lge_index}}
		{{leagueTime = moment(new DateTZ(lg.lt));}}
		{{var leagueEventName = lg.levn;}}
        {{var teamNames = leagueEventName.split(' vs ');}}
        {{var teamAName = teamNames[0];}}
		{{var teamBName = teamNames[1];}}
			{{var specialEvents = lg.se;}}
			{{var periods = Object.keys(specialEvents);}}
			{{~ periods :period:pe_index}}
			{{var expandedPeriods  = data.expandedPeriods  || [];}}
			{{var isSelectedPeriod = expandedPeriods.indexOf(Number(period)) > -1;}}
			<div class="special {{=isSelectedPeriod ? 'selected' : ''}}">
				<div class="special-header">
					{{=getPeriodsName(periodsDescription, sportId, period, false)}} - {{=i18n("Specials")}}</span>
					<span class="toggle-lg {{=isSelectedPeriod ? 'expand' : 'collapse' }} more-special"  id="mb-{{=currentClass}}_{{=lge_index}}_{{=period}}" />
				</div>
				<div class="special-content">
				{{~ specialEvents[period] :ev:ev_index}}
					<div class="contestant-line">
						<div class="special-name">
							{{?ev.e && lg.cg == 'Futures'}}
								<span>{{=ev.e}}&nbsp;:&nbsp;</span>
							{{?}}
							<span>{{=ev.n}}</span>
						</div>
						<div class="participants {{=ev.cg}}">
						{{var lines = ev.l;}}
						{{~lines :ctl:ctl_index}}
							{{var participant_count = participant_count + 1;}}
							<div id="{{=ctl.i}}" class='{{=participant_count%2==0?"even":""}} event-line participant border-bottom-right  {{=ctl_index%2==0?"":"col-border-right"}}'>
							<div class="event-name">
								{{? ctl.h > 0}}
								<span>{{=ctl.n}}&nbsp;{{=ctl.h}}&nbsp;{{=i18n(ev.un)}}</span>
								{{??}}
								<span>{{=ctl.n}}</span>
								{{?}}
							</div>
							<div class="event-odds">
								{{? ev.st != 'H'}}
								<a class="odds outright-odds {{=ctl.p < 0 ? 'neg' : ''}}"
									data-oddsid="{{=ctl.l}}" data-team-type="0" data-odds="{{=ctl.p}}" id='{{=ev.si}}|0|99|10|0|{{=ctl.h === null ? 0 : ctl.h}}|{{=ctl.i}}'
									data-category="{{=ev.cg}}" is-outright="1" >
                  {{? ot === OddsFormat.American}}
                    <span>{{? ctl.p > 0}}+{{?}}{{=ctl.p.toFixed(0)}}</span>
									{{??}}
										{{? ot === OddsFormat.Indonesian}}
											<span>{{=ctl.p.toFixed(2).formatSeparators()}}</span>
										{{??}}
											<span>{{=ctl.p.toFixed(3).formatSeparators()}}</span>
										{{?}}
									{{?}}
								</a>
								{{?}}
							</div>
							</div>
							{{ participant_count = 1; }}
						{{~}}
						{{? lines.length %2 !== 0 }}
							<div class='participant  border-bottom-right col-border-right'>&nbsp;</div>
						{{?}}
						</div>
					</div>
				{{~}}
				</div>
			</div>
			{{~}}
		{{~}}
	</div>    
  {{?}}

  {{var leagues = data.playerOutrights;}}
	{{?leagues && leagues.length > 0 && !isParlay}}    
	{{var currentClass = 'mk-po'; }}
	{{var isAddHidden = data.marketSecledted != 'All' && data.marketSecledted != 'Outright';}}
	<div class="more-outright more-market {{=currentClass}}{{= isAddHidden ? " hidden" : ""}}">
		{{~leagues :lg:lge_index}}
		{{leagueTime = moment(new DateTZ(lg.lt));}}
		{{var leagueEventName = lg.levn;}}
        {{var teamNames = leagueEventName.split(' vs ');}}
        {{var teamAName = teamNames[0];}}
		{{var teamBName = teamNames[1];}}
			{{var specialEvents = lg.se;}}
			{{var periods = Object.keys(specialEvents);}}
			{{~ periods :period:pe_index}}
			{{var expandedPeriods  = data.expandedPeriods  || [];}}
			{{var isSelectedPeriod = expandedPeriods.indexOf(Number(period)) > -1;}}
			<div class="special {{=isSelectedPeriod ? 'selected' : ''}}">
				<div class="special-header">
					<span class="header-name">{{=getPeriodsName(periodsDescription, sportId, period, false)}} - {{=i18n("Specials")}}</span>
					<span class="toggle-lg {{=isSelectedPeriod ? 'expand' : 'collapse' }} more-special"  id="mb-{{=currentClass}}_{{=lge_index}}_{{=period}}" />
				</div>
				<div class="special-content">
				{{~ specialEvents[period] :ev:ev_index}}
					<div class="contestant-line">
						<div class="special-name">
							{{?ev.e && lg.cg == 'Futures'}}
								<span>{{=ev.e}}&nbsp;:&nbsp;</span>
							{{?}}
							<span>{{=ev.n}}</span>
						</div>
						<div class="participants {{=ev.cg}}">
						{{var lines = ev.l;}}
						{{~lines :ctl:ctl_index}}
							{{var participant_count = participant_count + 1;}}
							<div id="{{=ctl.i}}" class='{{=participant_count%2==0?"even":""}} event-line participant border-bottom-right'>
							<div class="event-name">
								{{? ctl.h > 0}}
								<span>{{=ctl.n}}&nbsp;{{=ctl.h}}&nbsp;{{=i18n(ev.un)}}</span>
								{{??}}
								<span>{{=ctl.n}}</span>
								{{?}}
							</div>
							<div class="event-odds">
								{{? ev.st != 'H'}}
								<a class="odds outright-odds {{=ctl.p < 0 ? 'neg' : ''}}"
									data-oddsid="{{=ctl.l}}" data-team-type="0" data-odds="{{=ctl.p}}" id='{{=ev.si}}|0|99|10|0|{{=ctl.h === null ? 0 : ctl.h}}|{{=ctl.i}}'
									data-category="{{=ev.cg}}" is-outright="1" >
                  {{? ot === OddsFormat.American}}
                    <span>{{? ctl.p > 0}}+{{?}}{{=ctl.p.toFixed(0)}}</span>
									{{??}}
										{{? ot === OddsFormat.Indonesian}}
											<span>{{=ctl.p.toFixed(2).formatSeparators()}}</span>
										{{??}}
											<span>{{=ctl.p.toFixed(3).formatSeparators()}}</span>
										{{?}}
									{{?}}
								</a>
								{{?}}
							</div>
							</div>
							{{ participant_count = 1; }}
						{{~}}
						{{? lines.length %2 !== 0 }}
							<div class='participant  border-bottom-right'>&nbsp;</div>
						{{?}}
						</div>
					</div>
				{{~}}
				</div>
			</div>
			{{~}}
		{{~}}
	</div>    
  {{?}}
  
  {{?data.minuteMoreBets}}
    {{var minuteEv = data.minuteMoreBets[3];}}
    <!--Minutes Money Line -->  
    {{~ml_minuteMarkets.periods :periodNum:periodNum_index}}
      {{var period = minuteEv[8][periodNum];}}
      {{? period && period[4]}}
      {{var periodHDP = period[2];}} <!-- hdp -->
      {{var indexPeriodHDP = period[9][0];}} 
      {{_periodHDP = periodHDP[indexPeriodHDP];}}
      {{var currentClass = 'ml_' + ml_minuteMarkets.periods.join('_'); }}
      {{var isAddHidden = data.marketSecledted != 'All' && data.marketSecledted !== currentClass;}}
      <table class='more-ml more-market {{=currentClass}}{{= isAddHidden ? " hidden" : ""}}'>
        <thead>
          <tr>
            <th>
							{{=getPeriodsName(periodsDescription, sportId, period[5], false)}} - {{=i18n("others","e_moneyline")}}
              <span class="toggle-lg expand more-bets" id="mb-ml_{{=periodNum}}"/>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="mkline">
            <td>
              <div class="minutes event-details" data-eid='e{{=minuteEv[0]}}'>
                <div class="event-name {{=_periodHDP && (_periodHDP[6] || _periodHDP[5]) ? "": "no-underdog"}}">
                  <span class='home {{=_periodHDP && _periodHDP[5] ? "favSel": "sel"}}'/>
                  {{=minuteEv[1]}}
                </div>
                <div class="event-odds">
                  <a class="odds more-odds {{=period[4][1] < 0 ? 'fav neg': ''}}"
                    data-oddsid="{{=period[4][3]}}"
                    data-date="{{=minuteEv[4]}}"
                    data-pl-res="{{=minuteEv[22]}}"
                    data-team-type="{{=minuteEv[11][0]}}"
                    id="{{=minuteEv[0]}}|{{=periodNum}}|1|0|{{=period[4][4]?1:0}}|0"
                  >
                    {{? ot === OddsFormat.American}}
                      <span>{{? period[4][1] > 0}}+{{?}}{{=period[4][1]}}</span>
                    {{??}}
                      <span>{{=period[4][1].formatSeparators()}}</span>
                    {{?}}
                  </a>
                </div>
              </div>
            </td>
          </tr>
          <tr class="mkline">
            <td >
              <div class="minutes event-details" data-eid='e{{=minuteEv[0]}}'>
                <div class="event-name {{=_periodHDP && (_periodHDP[6] || _periodHDP[5]) ? "": "no-underdog"}}">
                  <span class='away {{=_periodHDP && _periodHDP[6] ? "favSel": "sel"}}'>{{=minuteEv[2]}}
                </div>
                <div class="event-odds">
                  <a class="odds more-odds {{=period[4][0] < 0 ? 'fav neg': ''}}"
                    data-oddsid="{{=period[4][3]}}"
                    data-date="{{=minuteEv[4]}}"
                    data-pl-res="{{=minuteEv[22]}}"
                    data-team-type="{{=minuteEv[11][1]}}"
                    id="{{=minuteEv[0]}}|{{=periodNum}}|1|1|{{=period[4][4]?1:0}}|0"
                  >
                    {{? ot === OddsFormat.American}}
                      <span>{{? period[4][0] > 0}}+{{?}}{{=period[4][0]}}</span>
                    {{??}}
                      <span>{{=period[4][0].formatSeparators()}}</span>
                    {{?}}
                  </a>
                </div>
              </div>
            </td>
          </tr>
          {{? period[4][2]}} <!-- Draw -->
          <tr class="mkline">
            <td>
              <div class="minutes event-details" data-eid='e{{=minuteEv[0]}}'>
                <div class="event-name">
                  <span class="draw">{{=i18n("Draw")}}</span>
                </div>
                <div class="event-odds">
                  <a class="odds more-odds {{=period[4][2] < 0 ? 'fav neg': ''}}"
                    data-oddsid="{{=period[4][3]}}"
                    data-date="{{=minuteEv[4]}}"
                    data-pl-res="{{=minuteEv[22]}}"
                    data-team-type="2"
                    id="{{=minuteEv[0]}}|{{=periodNum}}|1|2|{{=period[4][4]?1:0}}|0"
                  >
                    {{? ot === OddsFormat.American}}
                      <span>{{? period[4][2] > 0}}+{{?}}{{=period[4][2]}}</span>
                    {{??}}
                      <span>{{=period[4][2].formatSeparators()}}</span>
                    {{?}}
                  </a>
                </div>
              </div>
            </td>
          </tr>
          {{?}}
        </tbody>
      </table>
      {{?}} <!--if period -->
    {{~}}
    <!-- End Minutes Money Line -->  

    <!--Minutes HDP&OU --> 
	  {{~hdp_ou_minuteMarkets.periods :periodNum:periodNum_index}}
      {{var tempStartIndex = 0;}}
      {{var lines = new Array().init(minuteEv[3], 0);}}
      {{? lines.length > 0 && (lines[0] >= tempStartIndex)}}
      {{var period = minuteEv[8][periodNum];}}
      {{? period && period[3]&& period[2]}}     
      {{var _hdpLines =  period[2] || [];}}
      {{var _ouLines =  period[3] || [];}}
      {{? _hdpLines.length > tempStartIndex || _ouLines.length > tempStartIndex}}
      <!-- Check length of _hdpLines and _ouLines to display the HDP&OU more bets -->
      {{var isDisplayed = _hdpLines.length > 0 || _ouLines.length > 0;}}
      {{? isDisplayed}}
      {{var currentClass = 'hdp_ou_' + hdp_ou_minuteMarkets.periods.join('_'); }}
      {{var isAddHidden = data.marketSecledted != 'All' && data.marketSecledted !== currentClass;}}
      {{var resultingUnit = ev[27] && ev[27].toLowerCase() == 'regular' ? ev[32] : ev[27];}}
      <table class="more-HDPOU more-market {{=currentClass}}{{= isAddHidden ? " hidden" : ""}}">
        <thead>
          <tr>
            <th colspan="7">
						{{=getPeriodsName(periodsDescription, sportId, period[5], false)}} - {{=i18n(sportGroup,'HANDICAP')}} / {{=i18n(sportGroup,'Over Under')}} {{? ev[27] && ev[27].toLowerCase() !== 'regular' }}({{=i18n(ev[27])}}){{?}}
              <span class="toggle-lg expand more-bets" id="mb-hdp_ou_{{=periodNum}}" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class='header-content'>
            <td>{{=i18n('Event')}}</td>
            <td class="hdp more-hdp">{{=i18n('HDP')}}</td>
            <td class="odds more-odds"><span class="home-team-name" title="{{=homeTeamName}}"><span>{{=homeTeamName}}</span></span></td>
            <td class="odds more-odds"><span class="away-team-name" title="{{=awayTeamName}}"><span>{{=awayTeamName}}</span></span></td>
            <td class="hdp more-hdp">{{=i18n(resultingUnit)}}</td>
            <td class="odds more-odds">{{=i18n('Over')}}</td>
            <td class="odds more-odds">{{=i18n('Under')}}</td>
          </tr>
          {{~lines :line:line_index}}
          {{var _hdp = _hdpLines.length > line && _hdpLines[line];}}
          {{var _ou = _ouLines.length > line && _ouLines[line];}}
          {{? _hdp || _ou}}
          <tr class="mkline">
            {{?line == 0}}
              <td class='event-team-name {{=_hdp&&(_hdp[6]||_hdp[5])? "": "no-underdog"}}' rowspan={{=Math.max(_hdpLines.length, _ouLines.length)}}>
              <span class='home-away-team-name' title="{{=homeTeamName}} - {{=awayTeamName}}">
                <span class='{{=_hdp && _hdp[5] ? "favSel": "sel"}} home-team-name' title="{{=homeTeamName}}"><span>{{=homeTeamName}}</span></span>
                <span class='sign'>&nbsp;-&nbsp;</span>
                <span class='{{=_hdp && _hdp[6] ? "favSel": "sel"}} away-team-name' title="{{=awayTeamName}}"><span>{{=awayTeamName}}</span></span>
              </span>	
              </td>
            {{?}}
            <td class='hdp more-hdp'>
              <span class='hdp'>{{=_hdp ? _hdp[2].formatSeparators() : '&nbsp;'}}</span>
            </td>
            <td class="odds more-odds">
              {{? _hdp}}
              <a class="odds {{=_hdp[3] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=_hdp[7]}}"
                data-date="{{=minuteEv[4]}}"
                data-pl-res="{{=minuteEv[22]}}"
                data-team-type="{{=minuteEv[11][0]}}"
                id="{{=minuteEv[0]}}|{{=periodNum}}|2|0|{{=_hdp[8]?1:0}}|{{=_hdp[1]}}"
                >
                {{? ot === OddsFormat.American}}
                  <span>{{? _hdp[3] > 0}}+{{?}}{{=_hdp[3]}}</span>
                {{??}}
                  <span>{{=_hdp[3].formatSeparators()}}</span>
                {{?}}
              </a>
              {{??}}&nbsp;
              {{?}}                    
            </td>
            <td class="odds more-odds">
              {{? _hdp}}
              <a class="odds {{=_hdp[4] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=_hdp[7]}}"
                data-date="{{=minuteEv[4]}}"
                data-pl-res="{{=minuteEv[22]}}"
                data-team-type="{{=minuteEv[11][1]}}"
                id="{{=minuteEv[0]}}|{{=periodNum}}|2|1|{{=_hdp[8]?1:0}}|{{=_hdp[0]}}"
                >
                {{? ot === OddsFormat.American}}
                  <span>{{? _hdp[4] > 0}}+{{?}}{{=_hdp[4]}}</span>
                {{??}}
                  <span>{{=_hdp[4].formatSeparators()}}</span>
                {{?}}
              </a>
              {{??}}&nbsp;
              {{?}}                    
            </td>
            <td class='hdp more-hdp'>                    
              <span>{{=_ou ? _ou[0].formatSeparators(): '&nbsp;'}}</span>                    
            </td>
            <td class="odds more-odds">
              {{? _ou}}
              <a class="odds {{=_ou[2] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=_ou[4]}}"
                data-date="{{=minuteEv[4]}}"
                data-pl-res="{{=minuteEv[22]}}"
                data-team-type="0"
                id="{{=minuteEv[0]}}|{{=periodNum}}|3|3|{{=_ou[5]?1:0}}|{{=_ou[1]}}"
                >
                {{? ot === OddsFormat.American}}
                  <span>{{? _ou[2] > 0}}+{{?}}{{=_ou[2]}}</span>
                {{??}}
                  <span>{{=_ou[2].formatSeparators()}}</span>
                {{?}}
              </a>
              {{??}}
              &nbsp;
              {{?}}
            </td>
            <td class="odds more-odds">
              {{? _ou}}
              <a class="odds {{=_ou[3] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=_ou[4]}}"
                data-date="{{=minuteEv[4]}}"
                data-pl-res="{{=minuteEv[22]}}"
                data-team-type="1"
                id="{{=minuteEv[0]}}|{{=periodNum}}|3|4|{{=_ou[5]?1:0}}|{{=_ou[1]}}"
                >
                {{? ot === OddsFormat.American}}
                    <span>{{? _ou[3] > 0}}+{{?}}{{=_ou[3]}}</span>
                {{??}}
                  <span>{{=_ou[3].formatSeparators()}}</span>
                {{?}}
              </a>
              {{??}}
              &nbsp;
              {{?}}
            </td>
          </tr>
          {{?}}
          {{~}}
        </tbody>
      </table>
      {{?}}
      {{?}}
      {{?}}
      {{?}}
    {{~}}  
    <!-- End Minutes HDP&OU -->  
   
    <!--Minutes Team Total -->        
    {{~tt_minuteMarkets.periods :periodNum:periodNum_index}}
      {{var period = minuteEv[8][periodNum];}}
      {{? period && period[0]}}
      {{var fttt = period[0];}}
      {{var currentClass = 'tt_' + tt_minuteMarkets.periods.join('_'); }}
      {{var isAddHidden = data.marketSecledted != 'All' && data.marketSecledted !== currentClass;}}
      {{var resultingUnit = ev[27] && ev[27].toLowerCase() == 'regular' ? ev[32] : ev[27];}}
      <table class='more-TT more-market {{=currentClass}}{{= isAddHidden ? " hidden" : ""}}'>
        <thead>
          <tr>
            <th colspan="6">
							{{=getPeriodsName(periodsDescription, sportId, period[5], false)}} - {{=i18n(sportGroup,'Team Totals')}} {{? ev[27] && ev[27].toLowerCase() !== 'regular' }}({{=i18n(ev[27])}}){{?}}
              <span class="toggle-lg expand more-bets" id="mb-tt_{{=periodNum}}" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class='header-content'>
            <td class="hdp more-hdp"><span class="home-team-name" title="{{=homeTeamName}}"><span>{{=homeTeamName}}</span> {{=i18n(resultingUnit)}}</span></td>
            <td class="odds more-odds"><span class="home-team-name">{{=i18n('Over')}}</span></td>
            <td class="odds more-odds"><span class="home-team-name">{{=i18n('Under')}}</span></td>
            <td class="hdp more-hdp"><span class="away-team-name" title="{{=awayTeamName}}"><span>{{=awayTeamName}}</span> {{=i18n(resultingUnit)}}</span></td>
            <td class="odds more-odds"><span class="away-team-name">{{=i18n('Over')}}</span></td>
            <td class="odds more-odds"><span class="away-team-name">{{=i18n('Under')}}</span></td
          </tr>
          <tr class="mkline">
            <td class="hdp more-hdp">                    
              {{? fttt}}
                <span class='hdp'>{{=fttt[0][0].formatSeparators()}}</span>
              {{??}}
                &nbsp;
              {{?}}
            </td>
            <td class="odds more-odds">
              {{? fttt}}
              <a class="odds {{=fttt[0][2] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=fttt[0][4]}}"
                data-date="{{=minuteEv[4]}}"
                data-pl-res="{{=minuteEv[22]}}"
                data-team-type="{{=minuteEv[11][0]}}"
                id="{{=minuteEv[0]}}|{{=period[5]}}|4|5|{{=fttt[0][5]?1:0}}|{{=fttt[0][1]}}"
              >
                {{? ot === OddsFormat.American}}
                  <span>{{? fttt[0][2] > 0}}+{{?}}{{=fttt[0][2]}}</span>
                {{??}}
                  <span>{{=fttt[0][2].formatSeparators()}}</span>
                {{?}}
              </a>
              {{??}}&nbsp;
              {{?}}
            </td>                
            <td class="odds more-odds">
              {{? fttt}}
              <a class="odds {{=fttt[0][3] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=fttt[0][4]}}"
                data-date="{{=minuteEv[4]}}"
                data-pl-res="{{=minuteEv[22]}}"
                data-team-type="{{=minuteEv[11][0]}}"
                id="{{=minuteEv[0]}}|{{=period[5]}}|4|6|{{=fttt[0][5]?1:0}}|{{=fttt[0][1]}}"
              >
                {{? ot === OddsFormat.American}}
                  <span>{{? fttt[0][3] > 0}}+{{?}}{{=fttt[0][3]}}</span>
                {{??}}
                  <span>{{=fttt[0][3].formatSeparators()}}</span>
                {{?}}
              </a>
              {{??}}
                &nbsp;
              {{?}}
            </td>
            <td class="hdp more-hdp">
              {{? fttt}}
                <span class='hdp'>{{=fttt[1][0].formatSeparators()}}</span>
              {{??}}
                &nbsp;
              {{?}}
            </td>                
            <td class="odds more-odds">
              {{? fttt}}
              <a class="odds {{=fttt[1][2] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=fttt[1][4]}}"
                data-date="{{=minuteEv[4]}}"
                data-pl-res="{{=minuteEv[22]}}"
                data-team-type="{{=minuteEv[11][1]}}"
                id="{{=minuteEv[0]}}|{{=period[5]}}|5|7|{{=fttt[1][5]?1:0}}|{{=fttt[1][1]}}"
              >
                {{? ot === OddsFormat.American}}
                  <span>{{? fttt[1][2] > 0}}+{{?}}{{=fttt[1][2]}}</span>
                {{??}}
                  <span>{{=fttt[1][2].formatSeparators()}}</span>
                {{?}}
              </a>
              {{??}}
                &nbsp;
              {{?}}
            </td>                
            <td class="odds more-odds">
              {{? fttt}}
              <a class="odds {{=fttt[1][3] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=fttt[1][4]}}"
                data-date="{{=minuteEv[4]}}"
                data-pl-res="{{=minuteEv[22]}}"
                data-team-type="{{=minuteEv[11][1]}}"
                id="{{=minuteEv[0]}}|{{=period[5]}}|5|8|{{=fttt[1][5]?1:0}}|{{=fttt[1][1]}}"
              >
                {{? ot === OddsFormat.American}}
                  <span>{{? fttt[1][3] > 0}}+{{?}}{{=fttt[1][3]}}</span>
                {{??}}
                  <span>{{=fttt[1][3].formatSeparators()}}</span>
                {{?}}
              </a>
              {{??}}
                &nbsp;
              {{?}}
            </td>
          </tr>
        </tbody>
      </table>
      {{?}}
    {{~}} 
    <!-- End Minutes Team Total -->
  {{?}}

  <!-- Start render Corners -->

  {{?data.cornersMoreBets}}
  {{var ev = data.cornersMoreBets[3];}}
  {{var marketNo = data.marketNo.cornersPeriods;}}
  {{var periods = Object.keys(ev[8]);}}
  <!--1X2-->  
  {{var finalPeriods =periods.filter(function(p) {return p[5] === periodNum});}}
	{{? marketNo[periodNum]['ml'] > 0}}
	{{var period = ev[8][periodNum];}}
	{{? period && period[4]}}
	{{var _1x2 = period[4][2] > 0;}}
	{{var currentClass = 'mk-co'; }}
	{{var isAddHidden = data.marketSecledted != 'All' && data.marketSecledted !== currentClass;}}
	<table class='more-1x2 more-market {{=currentClass}}{{= isAddHidden ? " hidden" : ""}}'>
		<thead>
			<tr><th colspan="{{=_1x2 ? 3 : 2}}">
					{{=getPeriodsName(periodsDescription, sportId, period[5], false)}} - {{=i18n(sportGroup,'MORE_1x2')}}
					<span class="toggle-lg expand more-bets" id="mb-mk-co-1x2_{{=periodNum}}"/>
				</th>
			</tr>
		</thead>
		<tbody>
			<tr class='header-content'>
        <td><span class="home-team-name" title="{{=homeTeamName}}"><span>{{=homeTeamName}}</span></span></td>
				{{? _1x2}}
				<td>{{=i18n(sportGroup,'Draw')}}</td>
				{{?}}
        <td><span class="away-team-name" title="{{=awayTeamName}}"><span>{{=awayTeamName}}</span></span></td>
			</tr>
			<tr class="mkline">
				<td>
					<a class="odds more-odds {{=period[4][1] < 0 ? 'fav neg': ''}}"
					   data-oddsid="{{=period[4][3]}}"
                       data-date="{{=ev[4]}}"
					   data-pl-res="{{=ev[22]}}"
					   data-team-type="{{=ev[11][0]}}"
					   id="{{=ev[0]}}|{{=periodNum}}|1|0|{{=period[4][4]?1:0}}|0"
					   >
            {{? ot === OddsFormat.American}}
							<span>{{? period[4][1] > 0}}+{{?}}{{=period[4][1]}}</span>
						{{??}}
							<span>{{=period[4][1].formatSeparators()}}</span>
						{{?}}
					</a>
				</td>
				{{? _1x2}}
				<td>
					<a class="odds more-odds {{=period[4][2] < 0 ? 'fav neg': ''}}"
					   data-oddsid="{{=period[4][3]}}"
                       data-date="{{=ev[4]}}"
					   data-pl-res="{{=ev[22]}}"
					   data-team-type="2"
					   id="{{=ev[0]}}|{{=periodNum}}|1|2|{{=period[4][4]?1:0}}|0"
					   >
            {{? ot === OddsFormat.American}}
							<span>{{? period[4][2] > 0}}+{{?}}{{=period[4][2]}}</span>
						{{??}}
							<span>{{=period[4][2].formatSeparators()}}</span>
						{{?}}
					</a>
				</td>
				{{?}}
				<td>
					<a class="odds more-odds {{=period[4][0] < 0 ? 'fav neg': ''}}"
					   data-oddsid="{{=period[4][3]}}"
                       data-date="{{=ev[4]}}"
					   data-pl-res="{{=ev[22]}}"
					   data-team-type="{{=ev[11][1]}}"
					   id="{{=ev[0]}}|{{=periodNum}}|1|1|{{=period[4][4]?1:0}}|0"
					   >
            {{? ot === OddsFormat.American}}
							<span>{{? period[4][0] > 0}}+{{?}}{{=period[4][0]}}</span>
						{{??}}
							<span>{{=period[4][0].formatSeparators()}}</span>
						{{?}}
					</a>
				</td>
			</tr>
		</tbody>
	</table>
	{{?}} <!--if period -->
	{{?}}<!--if show1x2 -->

	<!--HDP&OU-->  
  {{~events :ev:ev_index}}
      {{var periods = Object.keys(ev[8]);}}    
      {{var finalPeriods =periods.filter(function(p) {return p[5] === periodNum});}}  
      {{var isValidPeriodNum = periodNum > 1;}}
      {{var tempStartIndex = 0;}}
      {{var lines = new Array().init(ev[3], isValidPeriodNum ? 0 : tempStartIndex);}}
      {{? lines.length > 0 && (lines[0] >= tempStartIndex || isValidPeriodNum)}}
      {{var period = ev[8][periodNum];}}
      {{? period && period[3]&& period[2]}}     
      {{var _hdpLines =  period[2] || [];}}
      {{var _ouLines =  period[3] || [];}}
      {{? _hdpLines.length > tempStartIndex || _ouLines.length > tempStartIndex || isValidPeriodNum}}
      <!-- Check length of _hdpLines and _ouLines to display the HDP&OU more bets -->
      {{var isDisplayed = _hdpLines.length > 0 || _ouLines.length > 0;}}
      {{? isDisplayed}}
      {{var currentClass = 'mk-co'; }}
      {{var isAddHidden = data.marketSecledted != 'All' && data.marketSecledted !== currentClass;}}
      <table class="more-HDPOU more-market {{=currentClass}}{{= isAddHidden ? " hidden" : ""}}">
        <thead>
          <tr>
            <th colspan="7">
              {{=getPeriodsName(periodsDescription, sportId, period[5], false)}} - {{=i18n(sportGroup,'HANDICAP')}} / {{=i18n(sportGroup,'Over Under')}} {{? ev[27] && ev[27].toLowerCase() != 'regular' }}({{=i18n(ev[27])}}){{?}}
              <span class="toggle-lg expand more-bets" id="mb-mk-co-hdp_{{=ev_index}}_{{=periodNum}}" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class='header-content'>
            <td>{{=i18n('Event')}}</td>
            <td class="hdp more-hdp">{{=i18n('HDP')}}</td>
            <td class="odds more-odds"><span class="home-team-name" title="{{=homeTeamName}}"><span>{{=homeTeamName}}</span></span></td>
					  <td class="odds more-odds"><span class="away-team-name" title="{{=awayTeamName}}">{{=i18n('others','HDP')}} <span>{{=awayTeamName}}</span></span></td>
            <td class="hdp more-hdp">{{=i18n('Goal')}}</td>
            <td class="odds more-odds">{{=i18n('Over')}}</td>
            <td class="odds more-odds">{{=i18n('Under')}}</td>
          </tr>
          {{~lines :line:line_index}}
          {{var _hdp = _hdpLines.length > line && _hdpLines[line];}}
          {{var _ou = _ouLines.length > line && _ouLines[line];}}
          {{? _hdp || _ou}}
          <tr class="mkline">
            {{?line == 0}}
              <td class='event-team-name {{=_hdp&&(_hdp[6]||_hdp[5])? "": "no-underdog"}}' rowspan={{=Math.max(_hdpLines.length, _ouLines.length)}}>
                <span class='home-away-team-name' title="{{=homeTeamName}} - {{=awayTeamName}}">
                  <span class='{{=_hdp && _hdp[5] ? "favSel": "sel"}} home-team-name' title="{{=homeTeamName}}"><span>{{=homeTeamName}}</span></span>
                  <span class='sign'>&nbsp;-&nbsp;</span>
                  <span class='{{=_hdp && _hdp[6] ? "favSel": "sel"}} away-team-name' title="{{=awayTeamName}}"><span>{{=awayTeamName}}</span></span>
                </span>	
              </td>
            {{?}}
            <td class='hdp more-hdp'>
              <span class='hdp'>{{=_hdp ? _hdp[2].formatSeparators() : '&nbsp;'}}</span>
            </td>
            <td class="odds more-odds">
              {{? _hdp}}
              <a class="odds {{=_hdp[3] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=_hdp[7]}}"
                          data-date="{{=ev[4]}}"
                data-pl-res="{{=ev[22]}}"
                data-team-type="{{=ev[11][0]}}"
                id="{{=ev[0]}}|{{=periodNum}}|2|0|{{=_hdp[8]?1:0}}|{{=_hdp[1]}}"
                >
                {{? ot === OddsFormat.American}}
                  <span>{{? _hdp[3] > 0}}+{{?}}{{=_hdp[3]}}</span>
                {{??}}
                  <span>{{=_hdp[3].formatSeparators()}}</span>
                {{?}}
              </a>
              {{??}}&nbsp;
              {{?}}                    
            </td>
            <td class="odds more-odds">
              {{? _hdp}}
              <a class="odds {{=_hdp[4] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=_hdp[7]}}"
                          data-date="{{=ev[4]}}"
                data-pl-res="{{=ev[22]}}"
                data-team-type="{{=ev[11][1]}}"
                id="{{=ev[0]}}|{{=periodNum}}|2|1|{{=_hdp[8]?1:0}}|{{=_hdp[0]}}"
                >
                {{? ot === OddsFormat.American}}
                  <span>{{? _hdp[4] > 0}}+{{?}}{{=_hdp[4]}}</span>
                {{??}}
                  <span>{{=_hdp[4].formatSeparators()}}</span>
                {{?}}
              </a>
              {{??}}&nbsp;
              {{?}}                    
            </td>
            <td class='hdp more-hdp'>                    
              <span>{{=_ou ? _ou[0].formatSeparators(): '&nbsp;'}}</span>                    
            </td>
            <td class="odds more-odds">
              {{? _ou}}
              <a class="odds {{=_ou[2] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=_ou[4]}}"
                          data-date="{{=ev[4]}}"
                data-pl-res="{{=ev[22]}}"
                data-team-type="0"
                id="{{=ev[0]}}|{{=periodNum}}|3|3|{{=_ou[5]?1:0}}|{{=_ou[1]}}"
                >
                {{? ot === OddsFormat.American}}
                  <span>{{? _ou[2] > 0}}+{{?}}{{=_ou[2]}}</span>
                {{??}}
                  <span>{{=_ou[2].formatSeparators()}}</span>
                {{?}}
              </a>
              {{??}}
              &nbsp;
              {{?}}
            </td>
            <td class="odds more-odds">
              {{? _ou}}
              <a class="odds {{=_ou[3] < 0 ? 'fav neg' : ''}}"
                data-oddsid="{{=_ou[4]}}"
                          data-date="{{=ev[4]}}"
                data-pl-res="{{=ev[22]}}"
                data-team-type="1"
                id="{{=ev[0]}}|{{=periodNum}}|3|4|{{=_ou[5]?1:0}}|{{=_ou[1]}}"
                >
                {{? ot === OddsFormat.American}}
                    <span>{{? _ou[3] > 0}}+{{?}}{{=_ou[3]}}</span>
                {{??}}
                  <span>{{=_ou[3].formatSeparators()}}</span>
                {{?}}
              </a>
              {{??}}
              &nbsp;
              {{?}}
            </td>
          </tr>
          {{?}}
          {{~}}
        </tbody>
      </table>
      {{?}}
      {{?}}
      {{?}}
      {{?}}
{{~}}

	<!--TT-->   
  {{~events :ev:ev_index}}
    {{var periods = Object.keys(ev[8]);}}   
    {{var finalPeriods =periods.filter(function(p) {return p[5] === periodNum});}}   
    {{? marketNo[periodNum]['tt'] > 0}}
    {{var period = ev[8][periodNum];}}
    {{? period && period[0]}}
    {{var fttt = period[0];}}
    {{var currentClass = 'mk-co'; }}
    {{var isAddHidden = data.marketSecledted != 'All' && data.marketSecledted !== currentClass;}}
    {{var resultingUnit = ev[27] && ev[27].toLowerCase() == 'regular' ? ev[32] : ev[27];}}
    <table class='more-TT more-market {{=currentClass}}{{= isAddHidden ? " hidden" : ""}}'>
      <thead>
        <tr>
          <th colspan="6">
            {{=getPeriodsName(periodsDescription, sportId, period[5], false)}} - {{=i18n(sportGroup,'Team Totals')}} {{? ev[27] && ev[27].toLowerCase() != 'regular' }}({{=i18n(ev[27])}}){{?}}
            <span class="toggle-lg expand more-bets" id="mb-mk-co-tt_{{=ev_index}}_{{=periodNum}}" />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class='header-content'>
          <td class="hdp more-hdp"><span class="home-team-name" title="{{=homeTeamName}}"><span>{{=homeTeamName}}</span> {{=i18n(resultingUnit)}}</span></td>
          <td class="odds more-odds"><span class="home-team-name">{{=i18n('Over')}}</span></td>
          <td class="odds more-odds"><span class="home-team-name">{{=i18n('Under')}}</span></td>
          <td class="hdp more-hdp"><span class="away-team-name" title="{{=awayTeamName}}"><span>{{=awayTeamName}}</span> {{=i18n(resultingUnit)}}</span></td>
          <td class="odds more-odds"><span class="away-team-name">{{=i18n('Over')}}</span></td>
          <td class="odds more-odds"><span class="away-team-name">{{=i18n('Under')}}</span></td>
        </tr>
        <tr class="mkline">
          <td class="hdp more-hdp">                    
            {{? fttt}}
              <span class='hdp'>{{=fttt[0][0].formatSeparators()}}</span>
            {{??}}
              &nbsp;
            {{?}}
          </td>
          <td class="odds more-odds">
            {{? fttt}}
            <a class="odds {{=fttt[0][2] < 0 ? 'fav neg' : ''}}"
              data-oddsid="{{=fttt[0][4]}}"
                        data-date="{{=ev[4]}}"
              data-pl-res="{{=ev[22]}}"
              data-team-type="{{=ev[11][0]}}"
              id="{{=ev[0]}}|{{=period[5]}}|4|5|{{=fttt[0][5]?1:0}}|{{=fttt[0][1]}}"
              >
              {{? ot === OddsFormat.American}}
                <span>{{? fttt[0][2] > 0}}+{{?}}{{=fttt[0][2]}}</span>
              {{??}}
                <span>{{=fttt[0][2].formatSeparators()}}</span>
              {{?}}
            </a>
            {{??}}&nbsp;
            {{?}}
          </td>                
          <td class="odds more-odds">
            {{? fttt}}
              <a class="odds {{=fttt[0][3] < 0 ? 'fav neg' : ''}}"
              data-oddsid="{{=fttt[0][4]}}"
              data-date="{{=ev[4]}}"
              data-pl-res="{{=ev[22]}}"
              data-team-type="{{=ev[11][0]}}"
              id="{{=ev[0]}}|{{=period[5]}}|4|6|{{=fttt[0][5]?1:0}}|{{=fttt[0][1]}}"
              >
                {{? ot === OddsFormat.American}}
                  <span>{{? fttt[0][3] > 0}}+{{?}}{{=fttt[0][3]}}</span>
                {{??}}
                  <span>{{=fttt[0][3].formatSeparators()}}</span>
                {{?}}
              </a>
            {{??}}
              &nbsp;
            {{?}}
          </td>
          <td class="hdp more-hdp">
            {{? fttt}}
              <span class='hdp'>{{=fttt[1][0].formatSeparators()}}</span>
            {{??}}
              &nbsp;
            {{?}}
          </td>                
          <td class="odds more-odds">
            {{? fttt}}
              <a class="odds {{=fttt[1][2] < 0 ? 'fav neg' : ''}}"
              data-oddsid="{{=fttt[1][4]}}"
              data-date="{{=ev[4]}}"
              data-pl-res="{{=ev[22]}}"
              data-team-type="{{=ev[11][1]}}"
              id="{{=ev[0]}}|{{=period[5]}}|5|7|{{=fttt[1][5]?1:0}}|{{=fttt[1][1]}}"
              >
                {{? ot === OddsFormat.American}}
                  <span>{{? fttt[1][2] > 0}}+{{?}}{{=fttt[1][2]}}</span>
                {{??}}
                  <span>{{=fttt[1][2].formatSeparators()}}</span>
                {{?}}
              </a>
            {{??}}
              &nbsp;
            {{?}}
          </td>                
          <td class="odds more-odds">
            {{? fttt}}
              <a class="odds {{=fttt[1][3] < 0 ? 'fav neg' : ''}}"
              data-oddsid="{{=fttt[1][4]}}"
              data-date="{{=ev[4]}}"
              data-pl-res="{{=ev[22]}}"
              data-team-type="{{=ev[11][1]}}"
              id="{{=ev[0]}}|{{=period[5]}}|5|8|{{=fttt[1][5]?1:0}}|{{=fttt[1][1]}}"
              >
                {{? ot === OddsFormat.American}}
                  <span>{{? fttt[1][3] > 0}}+{{?}}{{=fttt[1][3]}}</span>
                {{??}}
                  <span>{{=fttt[1][3].formatSeparators()}}</span>
                {{?}}
              </a>
            {{??}}
              &nbsp;
            {{?}}
          </td>
        </tr>
      </tbody>
    </table>
    {{?}}
    {{?}}<!--if showTT-->
    {{?}}
{{~}}
  <!--End Corners markets-->

  <!-- Start render Bookings -->

  {{?data.bookingsMoreBets}}
  {{var ev = data.bookingsMoreBets[3];}}
  {{var marketNo = data.marketNo.bookingsPeriods;}}
  {{var periods = Object.keys(ev[8]);}}
  <!--1X2--> 
  {{var finalPeriods =periods.filter(function(p) {return p[5] === periodNum});}}    
	{{? marketNo[periodNum]['ml'] > 0}}
	{{var period = ev[8][periodNum];}}
	{{? period && period[4]}}
	{{var _1x2 = period[4][2] > 0;}}
	{{var currentClass = 'mk-bo'; }}
	{{var isAddHidden = data.marketSecledted != 'All' && data.marketSecledted !== currentClass;}}
	<table class='more-1x2 more-market {{=currentClass}}{{= isAddHidden ? " hidden" : ""}}'>
		<thead>
			<tr><th colspan="{{=_1x2 ? 3 : 2}}">
					{{=getPeriodsName(periodsDescription, sportId, period[5], false)}} - {{=i18n(sportGroup,'MORE_1x2')}}
					<span class="toggle-lg expand more-bets" id="mb-mk-bo-1X2_{{=periodNum}}"/>
				</th>
			</tr>
		</thead>
		<tbody>
			<tr class='header-content'>
      <td><span class="home-team-name" title="{{=homeTeamName}}"><span>{{=homeTeamName}}</span></span></td>
				{{? _1x2}}
				<td>{{=i18n(sportGroup,'Draw')}}</td>
				{{?}}
        <td><span class="away-team-name" title="{{=awayTeamName}}"><span>{{=awayTeamName}}</span></span></td>
			</tr>
			<tr class="mkline">
				<td>
          {{? period[4][1] !== ''}}
            <a class="odds more-odds {{=period[4][1] < 0 ? 'fav neg': ''}}"
              data-oddsid="{{=period[4][3]}}"
                        data-date="{{=ev[4]}}"
              data-pl-res="{{=ev[22]}}"
              data-team-type="{{=ev[11][0]}}"
              id="{{=ev[0]}}|{{=periodNum}}|1|0|{{=period[4][4]?1:0}}|0"
              >
              {{? ot === OddsFormat.American}}
                <span>{{? period[4][1] > 0}}+{{?}}{{=period[4][1]}}</span>
              {{??}}
                <span>{{=period[4][1].formatSeparators()}}</span>
              {{?}}
            </a>
          {{??}}
            <span>&nbsp;</span>
          {{?}}
				</td>
				{{? _1x2}}
				<td>
          {{? period[4][2] !== ''}}
            <a class="odds more-odds {{=period[4][2] < 0 ? 'fav neg': ''}}"
              data-oddsid="{{=period[4][3]}}"
                        data-date="{{=ev[4]}}"
              data-pl-res="{{=ev[22]}}"
              data-team-type="2"
              id="{{=ev[0]}}|{{=periodNum}}|1|2|{{=period[4][4]?1:0}}|0"
              >
              {{? ot === OddsFormat.American}}
                <span>{{? period[4][2] > 0}}+{{?}}{{=period[4][2]}}</span>
              {{??}}
                <span>{{=period[4][2].formatSeparators()}}</span>
              {{?}}
            </a>
          {{??}}
            <span>&nbsp;</span>
          {{?}}
				</td>
				{{?}}
				<td>
          {{? period[4][0] !== ''}}
            <a class="odds more-odds {{=period[4][0] < 0 ? 'fav neg': ''}}"
              data-oddsid="{{=period[4][3]}}"
                        data-date="{{=ev[4]}}"
              data-pl-res="{{=ev[22]}}"
              data-team-type="{{=ev[11][1]}}"
              id="{{=ev[0]}}|{{=periodNum}}|1|1|{{=period[4][4]?1:0}}|0"
              >
              {{? ot === OddsFormat.American}}
                <span>{{? period[4][0] > 0}}+{{?}}{{=period[4][0]}}</span>
              {{??}}
                <span>{{=period[4][0].formatSeparators()}}</span>
              {{?}}
            </a>
          {{??}}
            <span>&nbsp;</span>
          {{?}}
				</td>
			</tr>
		</tbody>
	</table>
	{{?}} <!--if period -->
	{{?}}<!--if show1x2 -->

	<!--HDP&OU--> 
  {{~events :ev:ev_index}}
    {{var periods = Object.keys(ev[8]);}}  
    {{var finalPeriods =periods.filter(function(p) {return p[5] === periodNum});}}    
    {{var isValidPeriodNum = periodNum > 1;}}
    {{var tempStartIndex = 0;}}
    {{var lines = new Array().init(ev[3], isValidPeriodNum ? 0 : tempStartIndex);}}
    {{? lines.length > 0 && (lines[0] >= tempStartIndex || isValidPeriodNum)}}
    {{var period = ev[8][periodNum];}}
    {{? period && period[3]&& period[2]}}     
    {{var _hdpLines =  period[2] || [];}}
    {{var _ouLines =  period[3] || [];}}
    {{? _hdpLines.length > tempStartIndex || _ouLines.length > tempStartIndex || isValidPeriodNum}}
    <!-- Check length of _hdpLines and _ouLines to display the HDP&OU more bets -->
    {{var isDisplayed = _hdpLines.length > 0 || _ouLines.length > 0;}}
    {{? isDisplayed}}
    {{var currentClass = 'mk-bo'; }}
    {{var isAddHidden = data.marketSecledted != 'All' && data.marketSecledted !== currentClass;}}
    <table class="more-HDPOU more-market {{=currentClass}}{{= isAddHidden ? " hidden" : ""}}">
      <thead>
        <tr>
          <th colspan="7">
            {{=getPeriodsName(periodsDescription, sportId, period[5], false)}} - {{=i18n(sportGroup,'HANDICAP')}} / {{=i18n(sportGroup,'Over Under')}} {{? ev[27] && ev[27].toLowerCase() != 'regular' }}({{=i18n(ev[27])}}){{?}}
            <span class="toggle-lg expand more-bets" id="mb-mk-bo-hdp_{{=ev_index}}_{{=periodNum}}" />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class='header-content'>
          <td>{{=i18n('Event')}}</td>
          <td class="hdp more-hdp">{{=i18n('HDP')}}</td>
          <td class="odds more-odds"><span class="home-team-name" title="{{=homeTeamName}}"><span>{{=homeTeamName}}</span></span></td>
					<td class="odds more-odds"><span class="away-team-name" title="{{=awayTeamName}}"><span>{{=awayTeamName}}</span></span></td>
          <td class="hdp more-hdp">{{=i18n('Goal')}}</td>
          <td class="odds more-odds">{{=i18n('Over')}}</td>
          <td class="odds more-odds">{{=i18n('Under')}}</td>
        </tr>
        {{~lines :line:line_index}}
        {{var _hdp = _hdpLines.length > line && _hdpLines[line];}}
        {{var _ou = _ouLines.length > line && _ouLines[line];}}
        {{? _hdp || _ou}}
        <tr class="mkline">
          {{?line == 0}}
            <td class='event-team-name {{=_hdp&&(_hdp[6]||_hdp[5])? "": "no-underdog"}}' rowspan={{=Math.max(_hdpLines.length, _ouLines.length)}}>
              <span class='home-away-team-name' title="{{=homeTeamName}} - {{=awayTeamName}}">
                <span class='{{=_hdp && _hdp[5] ? "favSel": "sel"}} home-team-name' title="{{=homeTeamName}}"><span>{{=homeTeamName}}</span></span>
                <span class='sign'>&nbsp;-&nbsp;</span>
                <span class='{{=_hdp && _hdp[6] ? "favSel": "sel"}} away-team-name' title="{{=awayTeamName}}"><span>{{=awayTeamName}}</span></span>
              </span>
            </td>
          {{?}}
          <td class='hdp more-hdp'>
            <span class='hdp'>{{=_hdp ? _hdp[2].formatSeparators() : '&nbsp;'}}</span>
          </td>
          <td class="odds more-odds">
            {{? _hdp}}
            <a class="odds {{=_hdp[3] < 0 ? 'fav neg' : ''}}"
              data-oddsid="{{=_hdp[7]}}"
                        data-date="{{=ev[4]}}"
              data-pl-res="{{=ev[22]}}"
              data-team-type="{{=ev[11][0]}}"
              id="{{=ev[0]}}|{{=periodNum}}|2|0|{{=_hdp[8]?1:0}}|{{=_hdp[1]}}"
              >
              {{? ot === OddsFormat.American}}
                <span>{{? _hdp[3] > 0}}+{{?}}{{=_hdp[3]}}</span>
              {{??}}
                <span>{{=_hdp[3].formatSeparators()}}</span>
              {{?}}
            </a>
            {{??}}&nbsp;
            {{?}}                    
          </td>
          <td class="odds more-odds">
            {{? _hdp}}
            <a class="odds {{=_hdp[4] < 0 ? 'fav neg' : ''}}"
              data-oddsid="{{=_hdp[7]}}"
                        data-date="{{=ev[4]}}"
              data-pl-res="{{=ev[22]}}"
              data-team-type="{{=ev[11][1]}}"
              id="{{=ev[0]}}|{{=periodNum}}|2|1|{{=_hdp[8]?1:0}}|{{=_hdp[0]}}"
              >
              {{? ot === OddsFormat.American}}
                <span>{{? _hdp[4] > 0}}+{{?}}{{=_hdp[4]}}</span>
              {{??}}
                <span>{{=_hdp[4].formatSeparators()}}</span>
              {{?}}
            </a>
            {{??}}&nbsp;
            {{?}}                    
          </td>
          <td class='hdp more-hdp'>                    
            <span>{{=_ou ? _ou[0].formatSeparators(): '&nbsp;'}}</span>                    
          </td>
          <td class="odds more-odds">
            {{? _ou}}
            <a class="odds {{=_ou[2] < 0 ? 'fav neg' : ''}}"
              data-oddsid="{{=_ou[4]}}"
                        data-date="{{=ev[4]}}"
              data-pl-res="{{=ev[22]}}"
              data-team-type="0"
              id="{{=ev[0]}}|{{=periodNum}}|3|3|{{=_ou[5]?1:0}}|{{=_ou[1]}}"
              >
              {{? ot === OddsFormat.American}}
                <span>{{? _ou[2] > 0}}+{{?}}{{=_ou[2]}}</span>
              {{??}}
                <span>{{=_ou[2].formatSeparators()}}</span>
              {{?}}
            </a>
            {{??}}
            &nbsp;
            {{?}}
          </td>
          <td class="odds more-odds">
            {{? _ou}}
            <a class="odds {{=_ou[3] < 0 ? 'fav neg' : ''}}"
              data-oddsid="{{=_ou[4]}}"
                        data-date="{{=ev[4]}}"
              data-pl-res="{{=ev[22]}}"
              data-team-type="1"
              id="{{=ev[0]}}|{{=periodNum}}|3|4|{{=_ou[5]?1:0}}|{{=_ou[1]}}"
              >
              {{? ot === OddsFormat.American}}
                  <span>{{? _ou[3] > 0}}+{{?}}{{=_ou[3]}}</span>
              {{??}}
                <span>{{=_ou[3].formatSeparators()}}</span>
              {{?}}
            </a>
            {{??}}
            &nbsp;
            {{?}}
          </td>
        </tr>
        {{?}}
        {{~}}
      </tbody>
    </table>
    {{?}}
    {{?}}
    {{?}}
    {{?}}
{{~}}

	<!--TT-->  
  {{~events :ev:ev_index}}
    {{var periods = Object.keys(ev[8]);}}   
    {{var finalPeriods =periods.filter(function(p) {return p[5] === periodNum});}}       
    {{? marketNo[periodNum]['tt'] > 0}}
    {{var period = ev[8][periodNum];}}
    {{? period && period[0]}}
    {{var fttt = period[0];}}
    {{var currentClass = 'mk-bo'; }}
    {{var isAddHidden = data.marketSecledted != 'All' && data.marketSecledted !== currentClass;}}
    {{var resultingUnit = ev[27] && ev[27].toLowerCase() == 'regular' ? ev[32] : ev[27];}}
    <table class='more-TT more-market {{=currentClass}}{{= isAddHidden ? " hidden" : ""}}'>
      <thead>
        <tr>
          <th colspan="6">
            {{=getPeriodsName(periodsDescription, sportId, period[5], false)}} - {{=i18n(sportGroup,'Team Totals')}} {{? ev[27] && ev[27].toLowerCase() != 'regular' }}({{=i18n(ev[27])}}){{?}}
            <span class="toggle-lg expand more-bets" id="mb-mk-bo-tt_{{=ev_index}}_{{=periodNum}}" />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class='header-content'>
          <td class="hdp more-hdp"><span class="home-team-name" title="{{=homeTeamName}}"><span>{{=homeTeamName}}</span> {{=i18n(resultingUnit)}}</span></td>
          <td class="odds more-odds"><span class="home-team-name">{{=i18n('Over')}}</span></td>
          <td class="odds more-odds"><span class="home-team-name">{{=i18n('Under')}}</span></td>
					<td class="hdp more-hdp"><span class="away-team-name" title="{{=awayTeamName}}"><span>{{=awayTeamName}}</span> {{=i18n(resultingUnit)}}</span></td>
          <td class="odds more-odds"><span class="away-team-name">{{=i18n('Over')}}</span></td>
          <td class="odds more-odds"><span class="away-team-name">{{=i18n('Under')}}</span></td>
        </tr>
        <tr class="mkline">
          <td class="hdp more-hdp">                    
            {{? fttt}}
              <span class='hdp'>{{=fttt[0][0].formatSeparators()}}</span>
            {{??}}
              &nbsp;
            {{?}}
          </td>
          <td class="odds more-odds">
            {{? fttt}}
            <a class="odds {{=fttt[0][2] < 0 ? 'fav neg' : ''}}"
              data-oddsid="{{=fttt[0][4]}}"
              data-date="{{=ev[4]}}"
              data-pl-res="{{=ev[22]}}"
              data-team-type="{{=ev[11][0]}}"
              id="{{=ev[0]}}|{{=period[5]}}|4|5|{{=fttt[0][5]?1:0}}|{{=fttt[0][1]}}"
            >
              {{? ot === OddsFormat.American}}
                <span>{{? fttt[0][2] > 0}}+{{?}}{{=fttt[0][2]}}</span>
              {{??}}
                <span>{{=fttt[0][2].formatSeparators()}}</span>
              {{?}}
            </a>
            {{??}}&nbsp;
            {{?}}
          </td>                
          <td class="odds more-odds">
            {{? fttt}}
              <a class="odds {{=fttt[0][3] < 0 ? 'fav neg' : ''}}"
              data-oddsid="{{=fttt[0][4]}}"
              data-date="{{=ev[4]}}"
              data-pl-res="{{=ev[22]}}"
              data-team-type="{{=ev[11][0]}}"
              id="{{=ev[0]}}|{{=period[5]}}|4|6|{{=fttt[0][5]?1:0}}|{{=fttt[0][1]}}"
              >
                {{? ot === OddsFormat.American}}
                  <span>{{? fttt[0][3] > 0}}+{{?}}{{=fttt[0][3]}}</span>
                {{??}}
                  <span>{{=fttt[0][3].formatSeparators()}}</span>
                {{?}}
              </a>
            {{??}}
              &nbsp;
            {{?}}
          </td>
          <td class="hdp more-hdp">
            {{? fttt}}
              <span class='hdp'>{{=fttt[1][0].formatSeparators()}}</span>
            {{??}}
              &nbsp;
            {{?}}
          </td>                
          <td class="odds more-odds">
            {{? fttt}}
              <a class="odds {{=fttt[1][2] < 0 ? 'fav neg' : ''}}"
              data-oddsid="{{=fttt[1][4]}}"
              data-date="{{=ev[4]}}"
              data-pl-res="{{=ev[22]}}"
              data-team-type="{{=ev[11][1]}}"
              id="{{=ev[0]}}|{{=period[5]}}|5|7|{{=fttt[1][5]?1:0}}|{{=fttt[1][1]}}"
              >
                {{? ot === OddsFormat.American}}
                  <span>{{? fttt[1][2] > 0}}+{{?}}{{=fttt[1][2]}}</span>
                {{??}}
                  <span>{{=fttt[1][2].formatSeparators()}}</span>
                {{?}}
              </a>
            {{??}}
              &nbsp;
            {{?}}
          </td>                
          <td class="odds more-odds">
            {{? fttt}}
              <a class="odds {{=fttt[1][3] < 0 ? 'fav neg' : ''}}"
              data-oddsid="{{=fttt[1][4]}}"
              data-date="{{=ev[4]}}"
              data-pl-res="{{=ev[22]}}"
              data-team-type="{{=ev[11][1]}}"
              id="{{=ev[0]}}|{{=period[5]}}|5|8|{{=fttt[1][5]?1:0}}|{{=fttt[1][1]}}"
              >
                {{? ot === OddsFormat.American}}
                  <span>{{? fttt[1][3] > 0}}+{{?}}{{=fttt[1][3]}}</span>
                {{??}}
                  <span>{{=fttt[1][3].formatSeparators()}}</span>
                {{?}}
              </a>
            {{??}}
              &nbsp;
            {{?}}
          </td>
        </tr>
      </tbody>
    </table>
    {{?}}
    {{?}}<!--if showTT-->
    {{?}}
{{~}}
  <!--End Bookings markets-->
  
</div>

{{?}}
`;



// WEBPACK FOOTER //
// ./src/app/components/CompactView/OddsPageComponent/Templates/tennisTemplates/TennisMoreBets.js